import React from 'react'
import { FormControl } from 'react-bootstrap'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment'
import 'moment/locale/de'
import '../../index.css'
moment.locale('de')

const StatusSelect = (selectFilterInput, selectFilteredElements, filterOptions) => {
    return (
        <FormControl className="filterForm" defaultValue={selectFilterInput} as="select" size="sm" onChange={selectFilteredElements}>
            <option>All</option>
            {filterOptions.map(x => <option>{x}</option>)}
        </FormControl>
    )
}

const SimpleDateSelect = (handleDatePickerCallback, handleClearFilter, date = null, dateFix=false) => {
    console.log("SimpleDateSelect", handleDatePickerCallback, handleClearFilter, date)
    const startDate = date !== null ? date : moment(Date()).format("DD.MM.YYYY")
    const showCustomRangeLabel = false
    const dateDisabled = date != null && dateFix

    const handleApply = (event, picker) => {
        console.log("handleApply DateSelect", picker.startDate)
        console.log(picker.startDate)
        picker.element.val(
            picker.startDate.format('DD.MM.YYYY')
        )
        handleDatePickerCallback(picker.startDate)
    }
    const handleCancel = (event, picker) => {
        picker.element.val('')
        handleClearFilter()
    }

    return (
        <>
        <DateRangePicker disabled={dateDisabled} initialSettings={{
            singleDatePicker: true,
            showCustomRangeLabel: showCustomRangeLabel,
            locale: {
                cancelLabel: 'Zurücksetzen',
                applyLabel: 'Ok'
            },
            autoUpdateInput: false,

        }} onApply={handleApply} onCancel={handleCancel}
                onCallback={(start) => handleDatePickerCallback(start)} isClearable={false}>
                <FormControl className="dateFilterForm" size="sm" placeHolder="Lieferdatum" value={startDate} />
            </DateRangePicker>
            </>
    );
}

const DateSelect = (handleDatePickerCallback, handleClearFilter) => {
    const startDate = Date.now
    const endDate = Date.now
    const showCustomRangeLabel = false

    const handleApply = (event, picker) => {
        picker.element.val(
            picker.startDate.format('DD.MM.YYYY') +
            ' - ' +
            picker.endDate.format('DD.MM.YYYY')
        )
    }
    const handleCancel = (event, picker) => {
        picker.element.val('')
        handleClearFilter()
    }

    return (
        <DateRangePicker initialSettings={{
            showCustomRangeLabel,
            startDate, endDate,
            locale: {
                cancelLabel: 'Zurücksetzen',
                applyLabel: 'Ok'
            },
            autoUpdateInput: false,
            
            //ranges: {
            //    'Letzte 7 Tage': [
            //        moment().subtract(6, 'days').toDate(),
            //        moment().toDate(),
            //    ],
            //    'Letzte 30 Tage': [
            //        moment().subtract(29, 'days').toDate(),
            //        moment().toDate(),
            //    ],
            //    'Dieser Monat': [
            //        moment().startOf('month').toDate(),
            //        moment().endOf('month').toDate(),
            //    ],
            //    //'Bis heute': [
            //    //    null,
            //    //    moment().toDate(),
            //    //],
            //},
        }} onApply={handleApply} onCancel={handleCancel}
            onCallback={handleDatePickerCallback} isClearable={false}>
            <FormControl className="dateFilterForm" size="sm" />
        </DateRangePicker>
    );
}

const filteredElements = (allItemRows, dateFilterInput, selectFilterInput, filterInput) => {
    const allItemRowsCache = allItemRows
    let filteredBool = false

    if (filterInput.trim() != "") {
        allItemRows = allItemRows.filter(row => (row.key.includes("row_data_") && row.props.children.some(x => x.props != undefined && x.props.children != undefined && x.props.children.toString().toLocaleLowerCase().includes(filterInput.toLocaleLowerCase().toString()))))
        filteredBool = true
    }
    if (selectFilterInput != "All" && selectFilterInput != "") {
        allItemRows = allItemRows.filter(row => (row.key.includes("row_data_") && row.props.children.some(x => x.props.children != undefined && x.props.children == selectFilterInput)))
        filteredBool = true
    }
    if (dateFilterInput != "") {
        console.log(dateFilterInput)
        const startDate = moment(dateFilterInput.start._d).format("MM/DD/YYYY")
        const endDate = moment(dateFilterInput.end._d).format("MM/DD/YYYY")

        allItemRows = allItemRows.filter(row => (row.key.includes("row_data_")) &&
            ((moment(moment(row.props.children[3].props.children, "DD.MM.YYYY").format("MM/DD/YYYY"))).isSameOrBefore(endDate) &&
                (moment(moment(row.props.children[3].props.children, "DD.MM.YYYY").format("MM/DD/YYYY"))).isSameOrAfter(startDate)))

        filteredBool = true
    }

    if (filteredBool == true) {
        for (let row of allItemRowsCache) {
            if (row.key.includes("row_expanded_") && allItemRows.some(x => x.key.includes("row_data_" + row.key.split("_")[2]))) {
                let index = allItemRows.findIndex(x => x.key.includes(row.key.split("_")[2])) + 1
                allItemRows.splice(index, 0, row)
            }
        }
    }
    console.log("allItemRows ", allItemRows)
    return allItemRows
}

export { StatusSelect, DateSelect, SimpleDateSelect, filteredElements }